export const css = {
    root: '_19-323ft',
    active: '_3XeeogY_',
    ' _key': 'apic-theme/dojo/menu-item'
};
export default css;
